import actions from "./actions";

const { FETCH_ATTENDANCE_PERMISSIONS, RESET_ATTENDANCE_PERMISSIONS } = actions;

const initState = {
    attendancePermissions: []
};

const AttendancePermissionReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_ATTENDANCE_PERMISSIONS:
            return {
                ...state,
                attendancePermissions: data
            };
        case RESET_ATTENDANCE_PERMISSIONS:
            return {
                ...state,
                attendancePermissions: initState.attendancePermissions,
            };
        default:
            return state;
    }
};

export default AttendancePermissionReducer;
